export default __webpack_public_path__ + "static/media/real-estate-2.4f46172e.png";